import { TreatmentType } from 'app/core/enums';
import { isNeerVeneerLike } from './is-neer-veneer-like';

/** Returns whether a treatment uses the Neer design-product workflow. */
export function isNeerDesignProduct(treatmentTypeId?: TreatmentType | number | null): boolean {
  return isNeerVeneerLike(treatmentTypeId) || treatmentTypeId === TreatmentType.Moment;
}
